import { useSyncExternalStore } from "react";
import {
  getServiceUnavailable,
  subscribeToServiceUnavailable,
} from "../helpers/serviceUnavailable";

export const useServiceUnavailable = (): boolean =>
  useSyncExternalStore(
    subscribeToServiceUnavailable,
    getServiceUnavailable,
    getServiceUnavailable
  );
